Chart.register(ChartDataLabels);
let pieChart = newProportionPie(0)
function calsPerDay(){let e=parseFloat(document.querySelector('input[name="sexe"]:checked').value),t=document.querySelector('input[name="poids"]').value,a=document.querySelector('input[name="taille"]').value,u=document.querySelector('input[name="age"]').value,l=document.querySelector('input[name="nap"]:checked').value;
    let kcal = Math.round(e*t**.48*a**.5*u**-.13*l*100/4.18||0)   
    document.querySelector("span#totalCals").textContent=kcal;
    if (kcal > 0){
        console.log("show")
        pieChart.destroy()
        pieChart = newProportionPie(kcal);
        document.getElementById('pieChart').style.display  = "block";
    }else{
        console.log("hide")
        document.getElementById('pieChart').style.display = "none";
    }
}

function newProportionPie(kcal){
    let ctx = document.getElementById('pieChart');
    let labels = ["Glucides 🍞", "Protéines 🥩", "Lipides 🥑"];
    let Kj = kcal*4.18
    let values = [Math.round((47*Kj)/1700), Math.round((15*Kj)/ 1700), Math.round((37*Kj)/3800)];
    let colorHex = [
    "#EFCA08",
    "#FB3640",
    "#43AA8B"
    ];
    let newPieChart= new Chart(ctx, 
    {
        type: "pie",
        data: {
          labels: labels,
          datasets: [{
            data: values,
            backgroundColor: colorHex
          }]

        },
        options: {
            responsive: true,
            layout:{
                padding: {
                    left: 50,
                    right: 50,
                    top: 0,
                    bottom: 50
                }
            },
            plugins: {
                title: {
                    display: true,
                    text: "Répartition des besoins nutritionnels"
                  },
                legend: {
                    display: true,
                    position: 'bottom',
                    align: 'center'
                },
                datalabels: {
                    color: '#fff',
                    anchor: 'end',
                    align: 'start',
                    offset: -25,
                    borderWidth: 2,
                    borderColor: '#fff',
                    borderRadius: 25,
                    backgroundColor: (context) => {
                    return context.dataset.backgroundColor;
                    },
                    font: {
                    weight: 'bold',
                    size: '25'
                    },
                    formatter: (value) => {
                    return value + 'g';
                    }
                }
            }
        }
    });
    return newPieChart
}

